import $ from 'jquery';

$(window).on('load resize', function() {
    var headerHeight = $('.header').outerHeight();
    $('.main').css('padding-top', headerHeight);
});

// Menu mobile toggle .menu-mobile for display or hide .menu-main
$('.menu-mobile').on('click', function() {
    $(this).toggleClass('active');
    $('ul.menu-main').toggleClass('active');
    $('body').toggleClass('menu-active');

    // if active add header height to nav#block-gorgytime-main-menu ul.menu-main.active
    if ($('ul.menu-main').hasClass('active')) {
        var headerHeight = $('.header').outerHeight();
        $('nav#block-gorgytime-main-menu ul.menu-main.active').css('top', headerHeight);
        
        // height: calc(100vh - 135px); 135px = headerHeight
        $('nav#block-gorgytime-main-menu ul.menu-main.active .menu-main__item--expanded > ul.menu-main__submenu').css('height', 'calc(100vh - ' + headerHeight + 'px)');
    }

});

$(document).on('click', 'nav#block-gorgytime-main-menu ul.menu-main.active > li.menu-main__item--expanded > a', function(e) {
    e.preventDefault();
    $(this).siblings('ul').toggleClass('menu-main__submenu--expanded');

    // si il y a déjà un sous-menu ouvert, on le ferme avant d'ouvrir le nouveau
    $(this).parent().siblings().children('ul').removeClass('menu-main__submenu--expanded');

    // A l'ouverture d'un sous-menu, on ferme les autres et on affiche un span au dessus du sous-menu avec le nom du menu ouvert 
    var menuName = $(this).text();
    var menuNameSpan = '<span class="menu-main__submenu-name">' + menuName + '</span>';
    $(this).siblings('ul').prepend(menuNameSpan);
    $(this).parent().siblings().children('ul').children('span').remove();

    // if click to close submenu .menu-main__submenu-name remove class menu-main__submenu--expanded
    $(document).on('click', 'nav#block-gorgytime-main-menu ul.menu-main.active > li.menu-main__item--expanded > ul.menu-main__submenu--expanded > span.menu-main__submenu-name', function() {
        $(this).parent().removeClass('menu-main__submenu--expanded');
        $(this).remove();
    });
});

document.addEventListener("DOMContentLoaded", function() {
    var header = document.querySelector('header');
    window.onscroll = function() {
      if (window.pageYOffset > 80) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };
  });